module.exports = __webpack_public_path__ + "img/member_message_icon_435001.00b3b59d.png";